import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const packageData: Record<string, {
  name: string;
  packageTypes: string;
  price: string;
  position: number;
  publish: string;
  created: string;
}> = {
  '1': {
    name: '3-Class Renewal Package (select your own courses-9 hours)',
    packageTypes: 'generic package',
    price: '49.95',
    position: 1,
    publish: 'yes',
    created: '04/17/2011'
  },
  '2': {
    name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
    packageTypes: 'preset package',
    price: '89.95',
    position: 5,
    publish: 'yes',
    created: '04/17/2011'
  },
  '3': {
    name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
    packageTypes: 'generic package',
    price: '69.95',
    position: 3,
    publish: 'yes',
    created: '04/17/2011'
  }
};
export function ViewPackage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const pkg = packageData[id ?? '1'] ?? packageData['1'];
  return <div className="space-y-4" data-id="element-2635" data-mp="2nrzhn1lerls4">
      <div className="flex items-center justify-between" data-id="element-2636" data-mp="2nttt7pasi1jj">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2637" data-mp="2izg2w1aziklq">View Package</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages')} data-id="element-2638" data-mp="2e2fxztpvfnw7">
          ← Back to Packages
        </Button>
      </div>

      <Card data-id="element-2639" data-mp="201dadcj8a5j6">
        <CardContent className="pt-6" data-id="element-2640" data-mp="202wq920z2ekf">
          <div className="space-y-6" data-id="element-2641" data-mp="203zfl5inc8y8">
            {/* Details table */}
            <div data-id="element-2642" data-mp="1v43lpz3nxxwe">
              <h2 className="text-base font-semibold text-slate-800 mb-3" data-id="element-2643" data-mp="1v4mscjnv4zv4">
                Package
              </h2>
              <table className="text-sm w-full max-w-lg" data-id="element-2644" data-mp="3udjvb31xc0oo">
                <tbody data-id="element-2645" data-mp="3pi4jshre2gvf">
                  <tr className="border-b border-slate-100" data-id="element-2646" data-mp="3peqhtamn09oi">
                    <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2647" data-mp="cezf3gg70uvr">
                      Name
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2648" data-mp="h8vb4dcwc7oa">{pkg.name}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2649" data-mp="3h6vi03fv12k">
                    <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2650" data-mp="8fi9mn0rnxql">
                      Package Types
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2651" data-mp="w1x67yfoe77u">{pkg.packageTypes}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2652" data-mp="103aa42z7k0c4">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2653" data-mp="m524l6o3vqpc">
                      Price
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2654" data-mp="r71aan7bizpg">{pkg.price}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2655" data-mp="36urk7lwmvgj3">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2656" data-mp="3bvfi8rja4xmt">
                      Position
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2657" data-mp="349tji02ormao">{pkg.position}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2658" data-mp="2zc1vvi92qmca">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2659" data-mp="3dckyuayon27l">
                      Publish
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2660" data-mp="38drjse3qz35b">{pkg.publish}</td>
                  </tr>
                  <tr data-id="element-2661" data-mp="2kognp9xcdwxi">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2662" data-mp="2klksvugsjoda">
                      Created
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2663" data-mp="2ud70zhxu17bt">{pkg.created}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Actions */}
            <div data-id="element-2664" data-mp="21x62n9easedj">
              <h2 className="text-base font-semibold text-slate-800 mb-2" data-id="element-2665" data-mp="21wnxfn9nqpth">
                Actions
              </h2>
              <ul className="space-y-1 text-sm" data-id="element-2666" data-mp="1wyupaoosnlqk">
                <li data-id="element-2667" data-mp="1ww8m118xrse5">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate(`/packages/edit/${id}`)} data-id="element-2668" data-mp="2al1wgvqimh08">
                    Edit Package
                  </button>
                </li>
                <li data-id="element-2669" data-mp="2khogxjexj61q">
                  <button className="text-blue-600 hover:underline" data-id="element-2670" data-mp="2kh4wnw1t45kj">
                    Delete Package
                  </button>
                </li>
                <li data-id="element-2671" data-mp="2ta9o02977oaq">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages')} data-id="element-2672" data-mp="2tarudrpkriwd">
                    List Packages
                  </button>
                </li>
                <li data-id="element-2673" data-mp="388acwcbnszvd">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages/add')} data-id="element-2674" data-mp="387iszyrfcqkx">
                    New Package
                  </button>
                </li>
                <li data-id="element-2675" data-mp="1dwdtn6ndf0be">
                  <button className="text-blue-600 hover:underline" data-id="element-2676" data-mp="3r4kd737sgbu1">
                    List Package Courses
                  </button>
                </li>
                <li data-id="element-2677" data-mp="3mcsv7h2p7efi">
                  <button className="text-blue-600 hover:underline" data-id="element-2678" data-mp="3mc9axtpksdyb">
                    New Package Course
                  </button>
                </li>
              </ul>
            </div>

            {/* Related Package Courses */}
            <div data-id="element-2679" data-mp="dyk9msylfnwu">
              <h2 className="text-base font-semibold text-slate-800" data-id="element-2680" data-mp="dwzep28da2yg">
                Related Package Courses
              </h2>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}